import { useNavigate } from 'react-router';

import { useToast } from '@/components/ui/use-toast';
import { TokenTypeCode } from '@/services/types';
import {
  PropertyValidation,
  ServiceErrorCode,
} from '@/services/utils/service-error';

/**
 * Helper hook to process errors from the reset password form.
 */
export const useProcessError = () => {
  const { toast } = useToast();
  const navigate = useNavigate();

  return (
    form: any,
    {
      email,
      token,
    }: {
      email: string;
      token: string;
    },
    error: {
      code: ServiceErrorCode;
      validationErrorMap: PropertyValidation;
    },
  ) => {
    const { code, validationErrorMap } = error;

    switch (code) {
      case ServiceErrorCode.UnknownAccount: {
        form.setError('email', {
          message: "We couldn't find an account with that email address.",
        });
        break;
      }
      case ServiceErrorCode.PasswordReuse: {
        form.setError('password', {
          message: 'New password cannot match your old password.',
        });
        break;
      }
      case ServiceErrorCode.ValidationGuard: {
        if (validationErrorMap.password) {
          form.setError('password', {
            message:
              "This password isn't strong enough. Click the password meter for more information.",
          });
        }
        break;
      }
      case ServiceErrorCode.InvalidToken: {
        const params = new URLSearchParams({
          email,
          token,
          type: TokenTypeCode.RES_PWD,
          errorCode: ServiceErrorCode.InvalidToken,
        }).toString();
        navigate(`/verify/error?${params}`);
        break;
      }
      case ServiceErrorCode.UnknownError: {
        toast({
          variant: 'destructive',
          title: 'Uh oh! Something went wrong.',
          description: 'There was a problem resetting your password.',
        });
        break;
      }
      default: {
        toast({
          variant: 'destructive',
          title: 'Uh oh! Something went wrong.',
          description: 'There was a problem resetting your password.',
        });
      }
    }
  };
};
